import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Table from "react-bootstrap/Table";
import axios from "axios";
import App from "../../App";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";

let isMounted = false;

const AdminLanguage = (props) => {
  // admin langauge component which shows all the languages in the admin panel
  const [allLanguages, setallLanguages] = useState([]);
  const [languageForDisplayInTable, setLanguageForDisplayInTable] = useState();
  const [setLanguage, setsetLanguage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    // hides modal for add languages
    setShow(false);
    setErrorMessage("");
  };

  // opens modal for add languages
  const handleShow = () => setShow(true);

  const toastMessagePopUp = (message) => {
    // toast error message popup
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    // call function to grab all languages from api
    callLangaugesApi();
  }, []);

  useEffect(() => {
    // cleanup function
    return () => {
      isMounted = false;
    };
  }, []);

  const callLangaugesApi = () => {
    // api call to get all languages from museum id
    setLoader(true);
    let id = props.museum.id;
    const jsonObject = {
      filters: [
        {
          name: "museum_id",
          op: "eq",
          val: id,
        },
      ],
    };
    isMounted = true;
    axios
      .get(App.baseUrl + "api/language", {
        params: {
          q: JSON.stringify(jsonObject),
          page: 1,
          results_per_page: 20,
        },
      })
      .then((data) => {
        if (isMounted) {
          setallLanguages(data.data);
          setLanguagesInTable(data.data);
        }
      })
      .catch((error) => {
        toastMessagePopUp(error.message + ", please refresh page");
        if (isMounted) {
          setLoader(false);
        }
      });
  };

  const setLanguageApi = () => {
    // add new langauge post api to add languages, returns 404 if language exists
    isMounted = true;
    axios
      .post(App.baseUrl + "api/language", {
        name: setLanguage,
        museum_id: props.museum.id,
      })
      .then((data) => {
        if (isMounted) {
          callLangaugesApi();
          setsetLanguage("");
        }
      })
      .catch((error) => {
        if (error.response.status === 400) {
          toastMessagePopUp("Language already exists");
        } else {
          toastMessagePopUp(error.message);
        }
        if (isMounted) {
          setsetLanguage("");
        }
      });
  };

  const setLanguagesInTable = (objectArray) => {
    // sets languages get from api and inserts them in table <tr> component
    let allLanguageArray = [];
    if (objectArray.objects) {
      allLanguageArray = objectArray.objects.map((singleData, index) => {
        return (
          <tr key={singleData.id}>
            <td>{singleData.id}</td>
            <td>{singleData.name}</td>
          </tr>
        );
      });
    }
    setLanguageForDisplayInTable(allLanguageArray);
    setLoader(false);
  };

  const addLanguageHandler = (event) => {
    // add language handler, adds language in state setLanguage
    if (event.target.id === "form-ctrl-languagename") {
      setsetLanguage(event.target.value);
    }
  };

  const handleOnSubmit = (event) => {
    // on submit checks if that language exists with the languages get from callLangaugesApi() function if no values matches then calls setLanguageApi(); to set the new language
    const found = allLanguages.objects.find(
      (element) => element.name === setLanguage
    );
    if (setLanguage === "") {
      setErrorMessage("Language cannot be blank");
    } else if (found) {
      setErrorMessage("Language already exists");
    } else {
      setLanguageApi();
      handleClose();
    }
  };

  return (
    <div className="adminlanguage-content">
      {loader ? (
        <Spinner animation="border" />
      ) : (
        <div>
          <button
            onClick={handleShow}
            id="add-language-button"
            className="add-language-button"
          >
            Add language
          </button>
        </div>
      )}
      {loader ? null : (
        <div>
          <Table id="admin-language-table" striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Language name</th>
              </tr>
            </thead>
            <tbody>{languageForDisplayInTable}</tbody>
          </Table>
        </div>
      )}

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header id="admin-language-modal-header" closeButton>
          <Modal.Title>Language</Modal.Title>
        </Modal.Header>
        <Modal.Body id="admin-language-modal-body">
          <Form>
            <Form.Group>
              <Form.Label>Create a new language :</Form.Label>
              <Form.Control
                id="form-ctrl-languagename"
                type="text"
                onChange={addLanguageHandler}
                placeholder="Enter a new language name"
                autoComplete="off"
              />
            </Form.Group>
            <p className="show-alert" id="passsword-validation-error">
              {errorMessage}
            </p>
          </Form>
        </Modal.Body>
        <Modal.Footer id="admin-language-modal-footer">
          <button id="admin-language-modal-button" onClick={handleClose}>
            Close
          </button>
          <button id="admin-language-modal-button" onClick={handleOnSubmit}>
            Add language
          </button>
        </Modal.Footer>
      </Modal>
      <ToastContainer
        limit={1}
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    museum: state.museumData.museumData,
  };
};

export default connect(mapStateToProps, null)(AdminLanguage);
